import React from "react";
import { Bell, RotateCw } from "lucide-react";
import { LucideIcon } from "lucide-react";
import { ThemeType } from "../../types";
import { getThemeColors, getHeaderGradient } from "../../utils/theme";

interface PremiumHeaderProps {
  title: string;
  icon: LucideIcon;
  theme: ThemeType;
  showAvatar?: boolean;
  onNotificationClick: () => void;
  onRefreshClick?: () => void;
  isRefreshing?: boolean;
}

const PremiumHeader: React.FC<PremiumHeaderProps> = ({
  title,
  icon: Icon,
  theme,
  showAvatar = false,
  onNotificationClick,
  onRefreshClick,
  isRefreshing = false,
}) => {
  const colors = getThemeColors(theme);
  const gradient = getHeaderGradient(theme);

  return (
    <header className="pt-[calc(env(safe-area-inset-top)+0.75rem)] pb-3 px-6 flex justify-between items-center sticky top-0 bg-[#f8fafc]/80 backdrop-blur-xl z-20 border-b border-slate-200/50 text-left shrink-0">
      <div className="flex items-center gap-3">
        <div
          className={`w-8 h-8 rounded-md bg-gradient-to-tr ${gradient} flex items-center justify-center shadow-md rotate-3`}
        >
          <Icon
            className="w-[18px] h-[18px] text-white -rotate-3"
            strokeWidth={2.5}
          />
        </div>
        <h1
          className={`text-xl font-black tracking-tighter uppercase bg-gradient-to-r ${gradient} bg-clip-text text-transparent`}
        >
          {title}
        </h1>
      </div>
      <div className="flex items-center gap-2">
        {onRefreshClick && (
          <button
            onClick={onRefreshClick}
            disabled={isRefreshing}
            className="group inline-flex h-9 w-9 items-center justify-center rounded-lg hover:bg-slate-100 active:bg-slate-200 active:scale-95 active:shadow-inner transition-all duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
            title="データを更新"
          >
            <RotateCw
              className={`block w-5 h-5 text-slate-600 transition-transform duration-150 group-active:scale-90 group-active:-rotate-12 ${isRefreshing ? "animate-spin" : ""}`}
              strokeWidth={2}
            />
          </button>
        )}
        {showAvatar && (
          <div
            onClick={onNotificationClick}
            className="relative cursor-pointer hover:scale-105 transition-transform active:scale-95"
          >
            <div className="w-9 h-9 rounded-full bg-white border border-slate-200 flex items-center justify-center shadow-sm overflow-hidden">
              <Bell className="w-[18px] h-[18px] text-slate-500" />
            </div>
            <span
              className={`absolute -top-0.5 -right-0.5 w-3 h-3 ${colors.accent} border-2 border-[#f8fafc] rounded-full`}
            />
          </div>
        )}
      </div>
    </header>
  );
};

export default PremiumHeader;
